import { FormatNumber2 } from "../utility/functions/formatNumber";

export const IssueColumns = (width, onClickSearch) => {
  const columns = [
    {
      field: "ICODE",
      accessor: "ICODE",
      type: "string",
      headerAlign: "center",
      width: "15%",
      headerName: "Code",
      align: "left",
      headerClassName: "super-app-theme--header",
      renderCell: (param) => {
        return (
          <div>
            <button
              type="button"
              aria-label="Select item"
              title="Select item"
              onClick={(event) => {
                event.stopPropagation();
                onClickSearch(param);
              }}
            >
              <i className="bi bi-search mr-2 text-red-500 " />
            </button>
            {param.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Code
        </div>
      ),
    },

    {
      field: "ITEMNAME",
      accessor: "ITEMNAME",
      type: "string",
      headerAlign: "center",
      align: "left",
      headerName: "Item Name",

      width: "20%",

      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div className={` h-full w-full flex items-center  `}>
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Item Name
        </div>
      ),
    },
    {
      field: "PUR_BILL_NO",
      accessor: "PUR_BILL_NO",
      type: "string",
      headerAlign: "center",
      align: "left",
      headerName: "Purchase Bill No.",

      width: "10%",
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div className={` h-full w-full flex items-center  `}>
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Purchase Bill No.
        </div>
      ),
    },
    {
      field: "UNIT",
      accessor: "UNIT",
      type: "string",
      headerAlign: "center",
      align: "left",
      headerName: "Unit",

      width: "10%",
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div className={` h-full w-full flex items-center  `}>
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Unit
        </div>
      ),
    },
    {
      field: "PACKING",
      accessor: "PACKING",
      type: "string",
      headerAlign: "center",
      align: "left",
      headerName: "Packing",

      width: "10%",
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div className={` h-full w-full flex items-center  `}>
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Packing
        </div>
      ),
    },

    {
      field: "QNTY",
      accessor: "QNTY",
      type: "text",
      align: "left",
      headerName: "Quantity",

      width: "10%",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      editable: true,
      renderCell: (param) => {
        return (
          <div className={`h-full w-full  flex items-center   `}>
            {param.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Quantity
        </div>
      ),
    },

    {
      field: "RATE",
      accessor: "RATE",
      type: "number",
      width: "5%",
      align: "right",
      headerName: "Rate",

      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center  justify-end `}>
            {param.value ? FormatNumber2(param.value) : "0"}
          </div>
        );
      },

      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  pr-4 text-center" style={{ fontSize: 13 }}>
          Rate
        </div>
      ),
    },

    {
      field: "AMOUNT",
      accessor: "AMOUNT",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: "10%",
      align: "right",
      headerName: "Amount",

      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center  justify-end `}>
            {param.value ? FormatNumber2(param.value) : "0"}
          </div>
        );
      },

      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  pr-4 text-center" style={{ fontSize: 13 }}>
          Amount
        </div>
      ),
    },

    {
      field: "REMARKS",
      accessor: "REMARKS",
      type: "text",
      align: "left",
      isLast: true,
      width: "10%",
      headerName: "Remarks",

      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      editable: true,
      renderCell: (param) => {
        return (
          <div className={`h-full w-full  flex items-center   `}>
            {param.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Remarks
        </div>
      ),
    },
  ];

  return columns;
};
